import FieldType from '../datamodule/FieldType';

const VALIDATE_RULES = {
    //必填
    REQUIRED: 'required',
    //最大长度
    MAXLENGTH: 'maxlength',
    //电子邮件地址
    EMAIL: 'email',
    //电话
    PHONE: 'phone',
    //移动电话
    MOBILE: 'mobile',
    //整数
    INT: 'int',
    //正整数
    PINT: 'pint',
    //正数
    POSIT:'posit',
    //负整数
    NINT: 'nint',
    //日期
    DATE: 'date',
    //时间
    TIME: 'time',
    //日期时间
    DATETIME: 'datetime',
    //身份证号码
    IDNUMBER: 'idnumber',
    //无特殊字符
    NOSPECCHAR: 'nospecchar',
    //无脚本字符
    NOSCRIPT: 'noscript',
    //强密码
    PASSWORD: 'password',
    //中文
    CHINESE: 'chinese',
    //银行卡号
    BCNUMBER: 'bcnumber',
    //纳税人识别号
    TAXNUMBER: 'taxnumber',
    //统一社会信用编码
    USCC: 'uscc',
    //工商营业执照注册号
    BLNUMBER: 'blnumber',
    //货币
    CURRENCY: 'currency',
    //JSON
    JSON: 'json'
}

class ValidateRules {
    static required = (field)=> {
        return {required:true, message:`请输入${field.name}`, trigger:'blur'};
    }
    static maxlength = (field, rule)=> {
        return {validator:(_, value, cb)=> {
            if (!value) {
                cb();
                return;
            }
            if (value.length > rule.length) cb(new Error(`${field.name}输入长度已超过${rule.length}`));
            else cb();
        }, trigger:'blur'}
    }
    static email = (field, rule)=> {
        return {validator:(_, value, cb)=> {
            if (!value) { 
                cb();
                return;
            }
            // value = (value + '').replace(/^\s+|\s+$/, '');
            value = value + '';
            if (value && !(/^[\w\.]+\@\w+\.\w+$/.test(value))) cb(new Error(`${field.name}Email格式不正确`));
            else cb();
        }}
    }
    static phone = (field, rule)=> {
        return {validator:(_, value, cb)=> {
            if (!value) {
                cb();
                return;
            }
            value = value + '';
            if (value && !(/^(?:1[3-9]\d{9}|0\d{10,30})$/.test(value))) cb(new Error(`${field.name}电话号码格式不正确`));
            else cb();
        }}
    }
    static mobile = (field, rule)=> {
        return {validator:(_, value, cb)=> {
            if (!value) {
                cb();
                return;
            }
            value = value + '';
            if (value && !(/^1[3-9]\d{9}$/.test(value))) cb(new Error(`${field.name}电话号码格式不正确`));
            else cb();
        }}
    }
    static int = (field, rule)=> {
        return {validator:(_, value, cb)=> {
            if (!value) {
                cb();
                return;
            }
            value = value + '';
            if (value && !(/^[\+\-]?[1-9]+\d*$/.test(value))) cb(new Error(`${field.name}整数格式不正确`));
            else cb();
        }}
    }
    static pint = (field, rule)=> {
        return {validator:(_, value, cb)=> {
            if (!value) {
                cb();
                return;
            }
            value = value + '';
            if (value && !(/^\+?[1-9]+\d*$/.test(value))) cb(new Error(`${field.name}正整数格式不正确`));
            else cb();
        }}
    }
    static posit = (field, rule)=> {
        return {validator:(_, value, cb)=> {
            if (!value) {
                cb();
                return;
            }
            value = value + '';
            if (value && !(/^\+?(\d+)$|^\+?(\d+\.\d+)$/.test(value))) cb(new Error(`${field.name}正数格式不正确`));
            else cb();
        }}
    }
    
    static nint = (field, rule)=> {
        return {validator:(_, value, cb)=> {
            if (!value) {
                cb();
                return;
            }
            value = value + '';
            if (value && !(/^\-[1-9]+\d*$/.test(value))) cb(new Error(`${field.name}负整数格式不正确`));
            else cb();
        }}
    }
    static date = (field, rule)=> {
        return {validator:(_, value, cb)=> {
            if (!value) {
                cb();
                return;
            }
            value = value + '';
            if (value && !(/^\d{4}\-(\d{1,2})\-(\d{1,2})$/.test(value) && RegExp.$1 > 0 && RegExp.$1 <= 12 && RegExp.$2 > 0 && RegExp.$2 <= 31)) cb(new Error(`${field.name}日期格式不正确`));
            else cb();
        }}
    }
    static time = (field, rule)=> {
        return {validator:(_, value, cb)=> {
            if (!value) {
                cb();
                return;
            }
            value = value + '';
            if (value && !(/^(\d{1,2})\:(\d{1,2})\:(\d{1,2})$/.test(value) && RegExp.$1 <= 23 && RegExp.$2 <= 59 && RegExp.$3 <= 59)) cb(new Error(`${field.name}时间格式不正确`));
            else cb();
        }}
    }
    static datetime = (field, rule)=> {
        return {validator:(_, value, cb)=> {
            if (!value) {
                cb();
                return;
            }
            value = value + '';
            if (value && !(/^\d{4}\-(\d{1,2})\-(\d{1,2})\s(\d{1,2})\:(\d{1,2})\:(\d{1,2})$/.test(value) && RegExp.$1 > 0 && RegExp.$1 <= 12 && RegExp.$2 > 0 && RegExp.$2 <= 31 && RegExp.$3 <= 23 && RegExp.$4 <= 59 && RegExp.$5 <= 59)) cb(new Error(`${field.name}日期时间格式不正确`));
            else cb();
        }}
    }
    static idnumber = (field, rule)=> {
        return {validator:(_, value, cb)=> {
            if (!value) {
                cb();
                return;
            }
            value = value + '';
            if (value && !(/^\d{17}[\dXx]$/.test(value))) cb(new Error(`${field.name}日期时间格式不正确`));
            else cb();
        }}
    }
    static nospecchar = (field, rule)=> {
        return {validator:(_, value, cb)=> {
            if (!value) {
                cb();
                return;
            }
            value = value + '';
            if (value && (/[\~\!\@\#\$\%\^\&\*\(\)\|\{\}\'\:\;\,\[\]\.\<\>]/.test(value))) cb(new Error(`${field.name}不能包含 ~!@#$%^&*()|{}':;,[]<> 等特殊字符`));
            else cb();
        }}
    }
    static password = (field, rule)=> {
        return {validator:(_, value, cb)=> {
            if (!value) {
                cb();
                return;
            }
            value = value + '';
            if (value && !(/^[\~\!\@\#\$\%\^\&\*\(\)\-\+\_\=\|\{\}\'\:\;\,\[\]\.\<\>0-9\w]{16,32}$/.test(value) && /[\~\!\@\#\$\%\^\&\*\(\)\-\+\_\=\|\{\}\'\:\;\,\[\]\.\<\>]/.test(value) && /^[0-9]$/.test(value))) cb(new Error(`${field.name}密码必须包含数字以及 ~!@#$%^&*()|{}':;,[]<> 等特殊字符`));
            else cb();
        }}
    }
    static noscript = (field, rule)=> {
        return {validator:(_, value, cb)=> {
            if (!value) {
                cb();
                return;
            }
            value = value + '';
            if (value && (/[\s\<]script[\s\>]/i.test(value))) cb(new Error(`${field.name}不能包含 script 脚本字符`));
            else cb();
        }}
    }
    static chinese = (field, rule)=> {
        return {validator:(_, value, cb)=> {
            if (!value) {
                cb();
                return;
            }
            value = value + '';
            if (value && !(/^[\u4e00-\u9fa5]+$/.test(value))) cb(new Error(`${field.name}中文输入不正确`));
            else cb();
        }}
    }
    static bcnumber = (field, rule)=> {
        return {validator:(_, value, cb)=> {
            if (!value) {
                cb();
                return;
            }
            value = value + '';
            if (value && !(/^\d{5,50}$/.test(value))) cb(new Error(`${field.name}输入不正确`));
            else cb();
        }}
    }
    //纳税人识别号
    static taxnumber = (field, rule)=> {
        return {validator:(_, value, cb)=> {
            if (!value) {
                cb();
                return;
            }
            value = value + '';
            if (value && !(/^[\dA-Z]{15}([\dA-Z]{3}|[\dA-Z]{5})?$/.test(value))) cb(new Error(`${field.name}输入不正确`));
            else cb();
        }}
    }
    // 统一社会信用编码
    static uscc = (field, rule)=> {
        return {validator:(_, value, cb)=> {
            if (!value) {
                cb();
                return;
            }
            value = value + '';
            if (value && !(/^(?:([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10})|([1-9]\d{14}))$/.test(value) && (!rule || rule.length == 18 && RegExp.$1 || rule.length == 15 && RegExp.$2))) cb(new Error(`${field.name}输入不正确`));
            else cb();
        }}
    }
    // 营业执照号
    static blnumber = (field, rule)=> {
        return {validator:(_, value, cb)=> {
            if (!value) {
                cb();
                return;
            }
            value = value + '';
            if (value && !(/^(?:([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10})|([1-9]\d{14}))$/.test(value) && (!rule || rule.length == 18 && RegExp.$1 || rule.length == 15 && RegExp.$2))) cb(new Error(`${field.name}输入不正确`));
            else cb();
        }}
    }
    // 货币
    static currency = (field, rule)=> {
        return {validator:(_, value, cb)=> {
            if (!value) {
                cb();
                return;
            }
            value = value + '';
            console.log(value)
            if (value && !(/^\-?\d+(\.\d{1,4})?$/.test(value))) cb(new Error(`${field.name}货币格式不正确`));
            else cb();
        }}
    }

    static json = (field, rule)=> {
        return {validator:(_, value, cb)=> {
            if (!value) {
                cb();
                return;
            }
            value = value + '';
            try {
                JSON.parse(value)
                cb();
            } catch(e) {
                cb(new Error(`${field.name}JSON格式不正确`))
            }
        }}
    }

    static autocomplete = (field, rule)=> {
        return {validator:(_, value, cb)=> {
            if (!value) {
                cb();
                return;
            }
            // console.log('auto complete check', field, value, rule);
            if (field.dataOptions) {
                const data = field.dataOptions.dataInfo.getDataLocal(value, field.dataOptions.keyField);
                if (data) return cb();
                return cb(new Error(`${field.name}未选择有效数据`));
            }
            return cb();
        }}
    }

    static getRules(fields, module) {
        const result = {};
        for (const field of fields) {
            const f = field.field;
            const rules = [];
            if (field.type == FieldType.INPUT || field.type == FieldType.TEXTAREA) {
                rules.push('noscript');
            } else if (field.type == FieldType.AUTOCOMPLETE) {
                rules.push('autocomplete')
            }
            if (module) {
                const dataField = module.getDataField(f);
                if (dataField) {
                    const frules = dataField.getRules();
                    if (frules) for (const fr of frules) rules.push(fr);
                }
            }
            if (field.rules) {
                for (const r of field.rules) {
                    rules.push(r);
                }
            }
            if (!rules) continue;
            const rs = result[f] = [];
            for (const rule of rules) {
                const type = rule.type || rule;
                if (ValidateRules[type]) {
                    rs.push(ValidateRules[type](field, rule));
                }
            }
        }
        return result;
    }
}

export default ValidateRules;